import { dynamicFormListGetters } from '@/store/modules/dynamicFormList/routines'

export default {
  [dynamicFormListGetters.DYNAMIC_FORM_LIST]: state => state.dynamicFormList
}
